
import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import _ from "lodash"
function SeoStructuredData({ type, publisher, total, entity }) {   
  var ldJson = {
    "@context": "http://schema.org",
    "@type": type,
  };

  if (!_.isEmpty(publisher)) {
    ldJson['publisher'] = {
      "@type": "Corporation",
      "name": publisher.name,
      "logo": {
        "@type": "ImageObject",
        "url": publisher.logo,
        "width": 243,
        "height": 34
      }
    }
  }
  if (!_.isEmpty(entity)) {
    var itemListElement = [];
    if (!_.isEmpty(entity.list)) {
      _.forEach(entity.list, (val, key) => {
        itemListElement.push(
          {
            "@type": "ListItem",
            "position": key+1,
            "url": val.url,
            "name": val.name
            // "item": {
            //   "@type": "ListItem",
            //   "@id": val.id,
            //   "url": val.url,
            //   "name": val.name
            // }
          }
        ) 
      }) 
    }

    ldJson['mainEntity'] = {
      "@type": "ItemList",
      "numberOfItems": total,
      "name": entity.name,
      "description": entity.desc,
      "itemListElement": itemListElement
    }
  }
  
  return (
    <Helmet>
      <script defer type="application/ld+json">
        {JSON.stringify(ldJson, null, 2)}
      </script>
    </Helmet>
  )
}


export default SeoStructuredData
